import React from 'react';

import autoBind from 'react-autobind';

// import other components within the same project here

import Localization from "../../Localization.jsx"

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Icon,
} from '@material-ui/core';

import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  Legend
} from 'recharts';

import { withTheme } from '@material-ui/core/styles';

class StatisticsDialog extends React.Component {
  constructor(props) {
    super(props);
    this.refs = React.createRef();

    // state variables here
    this.state = {
      // aNumber : 1,
      // aString: "abc",
      // anArray: [],
      // anObject: {},
      open: false,
      barChartData: [],
    };
    autoBind(this);
  }

  handleClose() {
    this.setState({ open: false });
    this.state.open = false;
  }

  render() {
    let answerData = this.props.parent.state.currentAnswerData;
    if (answerData == null) {
      return (<div/>);
    }
    let icon = "";
    if (answerData.kind == "2") {
      icon = "list"
    } else if (answerData.kind == "4") {
      icon = "mic";
    }
    return (
      <div>
        <Dialog
          open={this.state.open}
          fullWidth={true}
          maxWidth={'md'}
          onClose={this.handleClose}
        >
          <DialogTitle>
            <Icon style={{fontSize: '36px', verticalAlign:'middle'}}>
              {icon}
            </Icon>
            {answerData['content']}
          </DialogTitle>
          <DialogContent>
            <BarChart
              width={600}
              height={300}
              data={this.state.barChartData}
            >
              <XAxis dataKey="name"/>
              <YAxis/>
              <Tooltip/>
              <Legend/>
              <Bar dataKey="Attempts" fill={this.props.theme.palette.primary.main}/>
            </BarChart>
          </DialogContent>
          <DialogActions style={{padding:'16px 24px'}}>
            <Button
              onClick={this.handleClose}
            >
              {Localization.strings.CLOSE}
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    )
  }
}

export default withTheme(StatisticsDialog);
